import React, { useState, useCallback } from 'react'
import { observer } from 'mobx-react'
import { ListSearch, EasyCustomTable, EasyImg, EasyModal, EasyIcon, FormPage } from 'src/components'
import { MSNManage } from './components'
import { mainStore } from 'enasops/stores'
import { $api, $consts } from 'src/plugins'
import { extendRulesAndGroups, getSingleRule, initFilter } from 'src/utils/common'
import { set } from 'lodash'
import 'enasops/styles/op/101/index.less'

const OP101 = () => {
  const [search, setSearch] = useState()

  const getList = (params: any) => {
    const { PageIndex, Limit, Rules, Groups } = params
    const payload = initFilter({ OrgId: mainStore.headers.OrgId, PageIndex, Limit })
    extendRulesAndGroups(payload, { Rules, Groups })
    return $api['op101/getCollectionOrderPaged'](
      payload,
      { fullData: true }
    ).then(res => {
      if (res?.IsSuccessful) {
        res.Data?.forEach((item: any, index: number) => {
          set(item, 'ID', item.Gateway?.ID ?? `collection_${index}`)
        })
      }
      return res
    })
  }

  const rowItem = useCallback((record: any) => {
    const handleNavMSN = () => {
      window.open(record.Sn?.Domain, '_blank')
    }

    const handleNav = () => {
      window.open(record.Ecm?.Domain, '_blank')
    }

    const { Gateway, Mqtt, Ecm, Sn } = record
    const typeDTU = Gateway.Type === $consts['ENUMS/GATE_TYPE_DTU']
    const msnConnect = Gateway.Status === $consts['ENUMS/GATE_STATUS_ONLINE'] ? require('enasops/assets/op/101/status-online.png') : require('enasops/assets/op/101/status-offline.png')
    const dtuConnect = Mqtt ? require('enasops/assets/op/101/status-online.png') : require('enasops/assets/op/101/status-offline.png')
    const mqConnect = Ecm ? require('enasops/assets/op/101/status-online.png') : require('enasops/assets/op/101/status-offline.png')

    if (!typeDTU) {
      return (
        <div className='op101__table-item'>
          {/** ECM */}
          <div className='item'>
            <EasyImg src={require('enasops/assets/op/101/gateway.png')} />
            <div className='item__detail'>
              <p>{Gateway?.Name}</p>
              <div className='item__detail-status'>
                <div>
                  <p>状态</p>
                  <p className={Gateway?.Status ? 'normal' : ''}>{Gateway?.Status ? '正常' : '--'}</p>
                </div>
                <div><p>S/N码</p><p>{Gateway?.SnNo}</p></div>
                <div><p>ECM类型</p><p>{Gateway?.TypeName}</p></div>
              </div>
              <div className='item__detail-link'>
                <span>所属租户：</span>
                {
                  Gateway?.TenantName
                    ? (
                      <EasyModal
                        fullModal
                        modal={{ title: '租户信息' }}
                        slot={<span>{Gateway?.TenantName}</span>}
                      >
                        <FormPage formCode='OP053' formData={{ formDisabled: true, formId: Gateway?.TenantId }} />
                      </EasyModal>
                    )
                    : <span>--</span>
                }
              </div>
            </div>
            <div className='item__btns gateway'>
              <EasyModal
                fullModal
                modal={{ title: 'Master&Slave关系' }}
                slot={
                  <React.Fragment>
                    <EasyImg src={require('enasops/assets/op/101/sn.png')} />
                    <span className='pd-l2'>SN</span>
                  </React.Fragment>
                }
                slotClass='item__btns-btn'
              >
                <MSNManage id={Gateway.ID} />
              </EasyModal>
              <div onClick={handleNavMSN} className='item__btns-btn nav-master sn-master'>进入Master</div>
            </div>
          </div>
          <EasyImg src={msnConnect} />
          {/** SN 从节点服务器 */}
          {
            Sn
              ? (
                <div className='item'>
                  <EasyImg src={require('enasops/assets/op/101/device.png')} />
                  <div className='item__detail'>
                    <p><span>{Sn?.Name}</span><span>{``}</span></p>
                    <div className='item__detail-status detail-two'>
                      <div><p>IP地址</p><p>{Sn?.IpAddress}</p></div>
                      <div><p>端口号</p><p>{Sn?.Port}</p></div>
                    </div>
                  </div>
                </div>
              )
              : (
                <div className='empty'>
                  <EasyImg src={require('enasops/assets/op/101/empty.png')} />
                  <p><span>暂无从节点服务器分配</span></p>
                </div>
              )
          }
        </div>
      )
    }

    return (
      <div className='op101__table-item'>
        {/** ECM */}
        <div className='item'>
          <EasyImg src={require('enasops/assets/op/101/gateway.png')} />
          <div className='item__detail'>
            <p>{Gateway?.Name}</p>
            <div className='item__detail-status'>
              <div>
                <p>状态</p>
                <p className={Gateway?.Status ? 'normal' : ''}>{Gateway?.Status ? '正常' : '--'}</p>
              </div>
              <div><p>S/N码</p><p>{Gateway?.SnNo}</p></div>
              <div><p>ECM类型</p><p>{Gateway?.TypeName}</p></div>
            </div>
            <div className='item__detail-link'>
              <span>所属租户：</span>
              {
                Gateway?.TenantName
                  ? (
                    <EasyModal
                      fullModal
                      modal={{ title: '租户信息' }}
                      slot={<span>{Gateway?.TenantName}</span>}
                    >
                      <FormPage formCode='OP053' formData={{ formDisabled: true, formId: Gateway?.TenantId }} />
                    </EasyModal>
                  )
                  : <span>--</span>
              }
            </div>
          </div>
          <div className='item__btns gateway'>
            <EasyModal
              modal={{ title: 'ECM配置' }}
              slot={
                <React.Fragment>
                  <EasyIcon type='SettingOutlined' size={16} />
                  <span className='pd-l2'>设置</span>
                </React.Fragment>
              }
              slotClass='item__btns-btn'
            >
              <FormPage formCode='OP086' formData={{ formId: Gateway.ID }} />
            </EasyModal>
            <EasyModal
              modal={{
                title: '绑定配置',
                width: '80%',
                styles: { body: { margin: '-12px -18px' } },
              }}
              slot={
                <React.Fragment>
                  <EasyIcon type='ApiOutlined' size={16} />
                  <span className='pd-l2'>{`绑定设备(${Gateway.EquipmentCount})`}</span>
                </React.Fragment>
              }
              slotClass='item__btns-btn'
            >
              <FormPage formCode='OP087' formData={{ filterGroup: { Rules: [getSingleRule('ID', 1, Gateway.ID)] } }} />
            </EasyModal>
          </div>
        </div>
        <EasyImg src={dtuConnect} />
        {/** MQTT服务器 */}
        {
          Mqtt
            ? (
              <div className='item'>
                <EasyImg src={require('enasops/assets/op/101/server.png')} />
                <div className='item__detail'>
                  <p><span>{Mqtt?.Name}</span><span>{`(${Mqtt.IpAddress})`}</span></p>
                  <div className='item__detail-status detail-two'>
                    <div><p>订阅主题</p><p title={Mqtt?.ReceiveMsg}>{Mqtt?.ReceiveMsg}</p></div>
                    <div><p>发送主题</p><p title={Mqtt?.SendMsg}>{Mqtt?.SendMsg}</p></div>
                  </div>
                </div>
              </div>
            )
            : (
              <div className='empty'>
                <EasyImg src={require('enasops/assets/op/101/empty.png')} />
                <p><span>分配MQTT主题失败，是否</span><span>手动分配</span></p>
              </div>
            )
        }
        {Mqtt ? <EasyImg src={mqConnect} /> : null}
        {/** ECM设备 */}
        {
          Mqtt
            ? (
              Ecm
                ? (
                  <div className='item'>
                    <EasyImg src={require('enasops/assets/op/101/device.png')} />
                    <div className='item__detail'>
                      <p><span>{Ecm?.Name}</span><span>{``}</span></p>
                      <div className='item__detail-status detail-two'>
                        <div><p>IP地址</p><p>{Ecm?.IpAddress}</p></div>
                        <div><p>端口号</p><p>{Ecm?.Port}</p></div>
                      </div>
                    </div>
                    <div className='item__btns'>
                      <div onClick={handleNav} className='item__btns-btn nav-master'>进入Master</div>
                    </div>
                  </div>
                )
                : (
                  <div className='empty'>
                    <EasyImg src={require('enasops/assets/op/101/empty.png')} />
                    <p><span>分配OPTiECM失败，是否</span><span>手动分配</span></p>
                  </div>
                )
            )
            : null
        }
      </div>
    )
  }, [])

  return (
    <div className='op101'>
      <ListSearch preventAutoData formCode='OP101' onSearch={setSearch} />
      <div className='op101__table'>
        <EasyCustomTable
          extraPayload={search}
          remoteMethod={getList}
          rowField={{ itemCount: 1, gapVertical: 0 }}
          rowItem={rowItem}
        />
      </div>
    </div>
  )
}

export default observer(OP101)